export type SUPPORTED_PAYOUT_METHOD_TYPE = "paypal" | "bank" | (string & {});

export interface PayoutMethodFee {
  description: string;
}

export interface PayoutMethod {
  key: SUPPORTED_PAYOUT_METHOD_TYPE;
  name: string;
  imageUrl: string;
  processingTime: string;
  fees: PayoutMethodFee[];
  isRecommended?: boolean;
}

export const PAYOUT_METHODS: Record<SUPPORTED_PAYOUT_METHOD_TYPE, PayoutMethod> = {
  paypal: {
    key: "paypal",
    name: "PayPal",
    imageUrl: "payout/paypal.png",
    processingTime: "1 business days",
    fees: [{ description: "PayPal fees may apply" }],
    isRecommended: true,
  },
  bank: {
    key: "bank",
    name: "Bank Transfer",
    imageUrl: "payout/bank.png",
    processingTime: "3–7 business days(varies by country)",
    fees: [
      { description: "US only(ACH): $1.00" },
      { description: "Global: IACH: $4.00, Wire(FX): $10.00, USD Wire: $25.00" },
    ],
  },
};
